import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftInsuranceProps } from './props';
import { SarlaftInsurance } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftInsurance = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftInsuranceProps) => {
    const onSubmit = (data: SarlaftInsurance) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'complaintsLastTwoYears',
            data?.complaintsLastTwoYears || ''
        );
    }, [data]);

    return {
        formik,
    };
};
